import { all, spawn } from 'redux-saga/effects'
import loginFlow from 'store/entities/identity/sagas'
import organizationsFlow from 'store/entities/organizations/sagas'
import protracksFlow from 'store/entities/protracks/sagas'
import levelsSaga from 'store/entities/protracks/levels/sagas'
import activitiesFlow from 'store/entities/protracks/activities/sagas'
import unsavedProtrackChangesSaga from 'store/entities/protracks/unsavedChanges/sagas'
import orgValuesSaga from 'store/entities/orgValues/sagas'
import uiSaga from 'store/entities/ui/sagas'
import adminOrganizationSaga from 'store/entities/organizations/sagas/adminOrganizationSaga'
import socketsFlow from 'store/entities/sockets/sagas'
import feedSaga from 'store/entities/feed/sagas'
import activityFlow from 'store/entities/activity/sagas'
import adminWelcomeEmailSaga from 'store/entities/adminWelcomeEmail/sagas'
import orgHollidaySaga from 'store/entities/orgHolidays/sagas'
import gallerySaga from 'store/entities/gallery/sagas'
import differentActivitiesSaga from 'store/entities/differentActivities/sagas'
import { sagas as organizationSettingsSaga } from './entities/organizationSettings'
import { sagas as orgInactiveNotificationsSaga } from './entities/orgInactiveNotifications'
import { onboardingSaga } from './entities/onBoarding/saga'
import { offlineSaga } from './entities/offline/saga'
import { analyticsSaga } from './entities/analytics/sagas'
import { localSettingsSaga } from './entities/localSettings/saga'
import typeForm from './entities/typeform/sagas'
import notificationsSaga from 'store/entities/notifications/sagas'
import storiesSaga from 'store/entities/stories/sagas'
import postReviewsUserReviewersSuccessSaga from 'store/entities/reviews/sagas/postReviewsUserReviewersSuccessSaga'
import postReviewsUserReminderBulkSuccessSaga from 'store/entities/reviews/sagas/postReviewsUserReminderBulkSuccessSaga'
import processReportsHandlerSaga from 'store/entities/reviews/sagas/processReportsHandlerSaga'
import generateActivitiesByCategoriesTagsSaga from 'store/entities/generator/sagas/generateActivitiesByCategoriesTagsSaga.ts'
import reviewsSurveyFlow from 'store/entities/reviewsSurveys/sagas'
import routerSaga from 'store/entities/router/sagas'

/** uncomment if you want to show all redux-actions in console */
// function* actionHelper() {
//   while (true) {
//     const action = yield require('redux-saga/effects').take()
//     console.log(action)
//   }
// }

export default function* (params) {
  yield all([
    /** uncomment if you want to show all redux-actions in console */
    // spawn(actionHelper),
    spawn(offlineSaga),
    spawn(loginFlow),
    spawn(organizationsFlow),
    spawn(unsavedProtrackChangesSaga),
    spawn(protracksFlow),
    spawn(levelsSaga),
    spawn(activitiesFlow),
    spawn(orgValuesSaga),
    spawn(adminOrganizationSaga),
    spawn(uiSaga),
    spawn(socketsFlow),
    spawn(feedSaga, params),
    spawn(activityFlow),
    spawn(adminWelcomeEmailSaga),
    spawn(organizationSettingsSaga),
    spawn(orgHollidaySaga),
    spawn(gallerySaga),
    spawn(orgInactiveNotificationsSaga),
    spawn(onboardingSaga),
    spawn(analyticsSaga),
    spawn(localSettingsSaga),
    spawn(differentActivitiesSaga),
    spawn(typeForm),
    spawn(notificationsSaga, params),
    spawn(storiesSaga),
    spawn(postReviewsUserReviewersSuccessSaga),
    spawn(processReportsHandlerSaga),
    spawn(postReviewsUserReminderBulkSuccessSaga),
    spawn(generateActivitiesByCategoriesTagsSaga),
    spawn(reviewsSurveyFlow),
    spawn(routerSaga),
  ])
}
